import React from 'react';
import { SocketContext } from '../contexts';

export const useSocket = () => {
  return React.useContext(SocketContext);
};
